// extracted by mini-css-extract-plugin
module.exports = {"cookieWrapper":"CookiePopupWrapper_cookieWrapper__H3Iy_"};